export interface CategoryIconRef { lib: 'mci' | 'ion' | 'feather'; name: string }

const FISH_KEYWORDS = ['fish', 'poisson', 'salmon', 'saumon', 'tuna', 'thon', 'shrimp', 'crevette',
  'cod', 'morue', 'trout', 'truite', 'tilapia', 'sardine', 'anchov', 'crab', 'crabe', 'lobster', 'homard'];

const CATEGORY_ICON: Record<string, CategoryIconRef> = {
  Meat:                  { lib: 'mci', name: 'food-drumstick-outline' },
  Vegetables:            { lib: 'mci', name: 'leaf' },
  Fruits:                { lib: 'mci', name: 'food-apple-outline' },
  Dairy:                 { lib: 'mci', name: 'cup-outline' },
  'Bread/Grains':        { lib: 'mci', name: 'baguette' },
  Condiments:            { lib: 'mci', name: 'bottle-tonic-outline' },
  Spices:                { lib: 'mci', name: 'shaker-outline' },
  'Packaged Foods':      { lib: 'feather', name: 'package' },
  Leftovers:             { lib: 'mci', name: 'bowl-mix-outline' },
  Beverages:             { lib: 'mci', name: 'bottle-soda-outline' },
  'Plant-Based Protein': { lib: 'mci', name: 'peanut-outline' },
  Other:                 { lib: 'feather', name: 'shopping-bag' },
};
const FISH_ICON: CategoryIconRef = { lib: 'ion', name: 'fish-outline' };
const FALLBACK_ICON: CategoryIconRef = CATEGORY_ICON.Other;

export function categoryIcon(category: string, name: string): CategoryIconRef {
  const n = (name || '').toLowerCase();
  if (category === 'Meat' && FISH_KEYWORDS.some((k) => n.includes(k))) return FISH_ICON;
  return CATEGORY_ICON[category] ?? FALLBACK_ICON;
}

/** Short reason label shown in chips ("Protéine", "Légume"…). */
const CATEGORY_LABEL_KEY: Record<string, string> = {
  Meat: 'pantry.cats.protein',
  'Plant-Based Protein': 'pantry.cats.protein',
  Vegetables: 'pantry.cats.vegetable',
  Fruits: 'pantry.cats.fruit',
  Dairy: 'pantry.cats.dairy',
  'Bread/Grains': 'pantry.cats.bread',
  Condiments: 'pantry.cats.condiment',
  Spices: 'pantry.cats.spice',
  'Packaged Foods': 'pantry.cats.staple',
  Beverages: 'pantry.cats.beverage',
  Leftovers: 'pantry.cats.leftover',
  Other: 'pantry.cats.staple',
};
export function categoryLabelKey(category: string): string {
  return CATEGORY_LABEL_KEY[category] ?? 'pantry.cats.staple';
}
